import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { MainDiv, Icon, MainSection, OuterDiv } from './style';
import SVGIcon from '../../../../assets/images/svg/SVGIcon';
import ProjectDetails from './projectDetails/projectDetails';
import RightSection from './rightSection/rightSection';
import { useHistory } from 'react-router-dom';
import { rootStore } from '../../../../mobx/rootStore';
import { useDispatch } from 'react-redux';
import { getCustomerList } from '../../../../services/customerServices';
import { getProjectTemplateList } from '../../../../services/settingServices';
import { isEmpty } from '../../../../helpers/common';
import ModalCustom from '../../../../component/models/modal';
import InviteTeamsModal from '../../../../component/models/inviteTeamsModal';
import { useMobileDevice } from '../../../../global/useMobile';
import { observer } from 'mobx-react-lite';
import { CREATE_PROJECT_STEP } from '../../../../global/constants';
import TeamMembers from './teamMember/teamMembers';
import ResponsiveHeader from '../../../../component/responsiveHeader/header';
import BottomSubNavigation from '../../../../component/bottomNavigation/subNavigation';

function CreateProjectStep2() {
  //State variables
  const [inviteModelOpen, setInviteModelOpen] = useState(false);
  const [createProjectStep, setCreateProjectStep] = useState(CREATE_PROJECT_STEP.ADD_INFO);

  //Mobx store variables
  const { workspaceStore, projectStore } = rootStore;
  const { currentWorkspace } = workspaceStore;
  const { createProjectInput } = projectStore;

  //Other variables
  const history = useHistory();
  const dispatch = useDispatch();
  const isMobile = useMobileDevice();

  //Load Initial Data
  const loadData = useCallback(async () => {
    if (!isEmpty(currentWorkspace?.id)) {
      let promises = [dispatch(getCustomerList())];
      if (isEmpty(createProjectInput?.id)) promises.push(dispatch(getProjectTemplateList(currentWorkspace?.id)));
      await Promise.all(promises);
    }
  }, [dispatch, createProjectInput?.id, currentWorkspace?.id]);

  useEffect(() => {
    loadData();
    return () => {
      createProjectInput?.clear();
    };
  }, [createProjectInput, loadData]);

  const handleCloseModal = useCallback(() => {
    setInviteModelOpen(false);
  }, []);

  const onClickBack = useCallback(() => {
    if (createProjectStep === CREATE_PROJECT_STEP.ADD_MEMBER) {
      setCreateProjectStep(CREATE_PROJECT_STEP.ADD_INFO);
    } else {
      history.goBack();
    }
  }, [createProjectStep, history]);

  const onClickCancel = useCallback(() => {
    history.push('/projects');
  }, [history]);

  const renderCloseIcon = useMemo(() => {
    return (
      <Icon className='closeIcon' onClick={onClickCancel}>
        <SVGIcon name='new-close-icon' width='20' height='20' viewBox='0 0 18 18' fill='var(--text-secondary)' />
      </Icon>
    );
  }, [onClickCancel]);

  return (
    <>
      <OuterDiv>
        {isMobile ? (
          <ResponsiveHeader
            Title={createProjectStep === CREATE_PROJECT_STEP.ADD_INFO ? 'Add project details' : 'Team members'}
            noMargin={true}
            leftElement={renderCloseIcon}
          />
        ) : (
          <>
            <Icon className='backIcon' onClick={onClickBack}>
              <SVGIcon
                name='new-left-arrow-icon'
                width='20'
                height='20'
                viewBox='0 0 18 18'
                fill='var(--text-secondary)'
              />
            </Icon>
            {renderCloseIcon}
          </>
        )}
        <MainDiv>
          <MainSection>
            {createProjectStep === CREATE_PROJECT_STEP.ADD_INFO ? (
              <ProjectDetails onClickCreate={() => setCreateProjectStep(CREATE_PROJECT_STEP.ADD_MEMBER)} />
            ) : (
              <TeamMembers setInviteModelOpen={() => setInviteModelOpen(true)} />
            )}
            {!isMobile && <RightSection />}
          </MainSection>
          <ModalCustom
            open={inviteModelOpen}
            onClose={handleCloseModal}
            width={400}
            isTracker={isMobile ? false : true}>
            <InviteTeamsModal onCancel={handleCloseModal} workspace_id={currentWorkspace?.id!} isCreateProject={true} />
          </ModalCustom>
        </MainDiv>
      </OuterDiv>
      <BottomSubNavigation handleBackIcon={onClickBack} />
    </>
  );
}

export default observer(CreateProjectStep2);
